import * as React from "react";
import { css } from "@emotion/react";
import f from "@/module/Utils/emotion";
import v from "@/module/Utils/variable";
import { globFunc } from "@/store";

//Assets
import ubbSp from "@/images/common/icon_UBB_sp.svg";
import ubbPc from "@/images/common/icon_UBB_pc.svg";
import ShiseidoSP from "@/images/common/icon_shiseido_sp.svg";

//Components
import Picture from "@/components/Atoms/Picture";
import FloatGradation from "@/images/common/float_gradation-top.png";
import Link from "@/components/Atoms/Link";

const Header: React.FC = () => {
  const headerWrapStyle = css({
    [f.sp()]: {
      display: "flex",
      justifyContent: "space-between",
      width: "100vw",
      pointerEvents: "none",
    },
    "&:before": {
      content: "''",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      backgroundImage: `url(${FloatGradation})`,
      backgroundSize: "100% 100%",
      backgroundPosition: "top left",
      backgroundRepeat: "no-repeat",
      touchAction: "none",
      pointerEvents: "none",
      userSelect: "none",
      [f.sp()]: {
        height: f.vw(229, v.spWidth),
      },
      [f.pc()]: {
        height: f.vw(130),
      },
    },
    [f.pc()]: {
      display: "flex",
      justifyContent: "space-between",
      width: "100vw",
    },
  });

  const ubbStyle = css({
    pointerEvents: "auto",
    position: "relative",
    [f.sp()]: {
      width: f.vw(157.6, v.spWidth),
      margin: `${f.vw(53.5, v.spWidth)} 0 0 ${f.vw(48, v.spWidth)}`,
    },
    [f.pc()]: {
      width: f.vw(148, v.pcWidth),
      margin: `${f.vw(53.5, v.pcWidth)} 0 0 ${f.vw(48, v.pcWidth)}`,
      transition: "opacity 0.5s ease-out",
      "&:hover": {
        opacity: 0.6,
      },
    },
  });

  const shiseidoStyle = css({
    pointerEvents: "auto",
    position: "relative",
    [f.sp()]: {
      width: f.vw(170, v.spWidth),
      margin: `${f.vw(49.5, v.spWidth)} ${f.vw(51, v.spWidth)} 0 0`,
    },
    [f.pc()]: {
      width: f.vw(148, v.pcWidth),
      margin: `${f.vw(49.5, v.pcWidth)} ${f.vw(51, v.pcWidth)} 0 0`,
      transition: "opacity 0.5s ease-out",
      "&:hover": {
        opacity: 0.6,
      },
    },
  });

  //logics
  const handleBeforeLeave = (resolve) => {
    globFunc.getState().sketch.drawCloseEye(() => {
      resolve();
    });
  };

  return (
    <div css={headerWrapStyle}>
      <div css={ubbStyle}>
        <Link
          to={"/"}
          onBeforeLeave={handleBeforeLeave}
          gaClass={"u-ga-seeubb_header_logo-shiseido"}
        >
          <Picture
            path={{ pc: ubbPc, sp: ubbSp }}
            alt={"SEE, SAY, DO.See UBB"}
          />
        </Link>
      </div>
      <a
        href={"https://international.shiseido.co.jp/"}
        target={"_blank"}
        css={shiseidoStyle}
        className={"u-ga-seeubb_header_logo-top"}
      >
        <Picture path={ShiseidoSP} alt={"SHISEIDO GINZA TOKYO"} />
      </a>
    </div>
  );
};

export default Header;
